import { useAuthStore } from '@clarix/auth-store';
import { getWorkspaceSlug } from '@/gateway/getWorkspaceSlug';

/**
 * Which workspace a mailed PMS link belongs to.
 *
 * Three sources, most explicit first. The mailed link is `{slug}.clarix.app`, so
 * the hostname normally answers it — but that is exactly the thing that is absent
 * in the two cases people actually hit:
 *
 *   1. `?ws=` — an explicit override. Bare `localhost:5000` has no subdomain to
 *      read, and this is what makes a copy-pasted dev link work at all.
 *   2. the hostname — production, and `{slug}.localhost:5000` in dev.
 *   3. the session — a signed-in user on the apex or in single-host mode
 *      (`VITE_SINGLE_HOST=true`), where the workspace comes from `/me` rather
 *      than the URL. Only helps someone already signed in, which is fine: it is
 *      the fallback, not the mechanism.
 *
 * A signed-out reader on a slugless host genuinely cannot be resolved, and that
 * is the one case that still refuses the link.
 *
 * Shared by BOTH public PMS links — the employee's `/pms/eval/:token` and the
 * manager's `/pms/eval/rm/:token`. They resolve the workspace identically, and a
 * second copy would be a rule that could drift on one page only.
 */
export function resolvePmsLinkSlug(explicit: string | null): string | null {
  if (explicit) return explicit;
  const fromHost = getWorkspaceSlug();
  if (fromHost) return fromHost;
  return useAuthStore.getState().workspaceSlug ?? null;
}
